import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  fetchAdminById,
  updateAdminPassword,
} from "../../services/apiServices";
import {
  Button,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Alert,
  Form,
  FormGroup,
} from "reactstrap";
import { toast } from "react-toastify";

const UpdateAdminPassword = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [admin, setAdmin] = useState({ email: "" });
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch admin email
  useEffect(() => {
    const getAdmin = async () => {
      try {
        setLoading(true);
        const res = await fetchAdminById(id);
        const adminData = res?.data?.data || res?.data || res;
        setAdmin({ email: adminData.email || "" });
      } catch (err) {
        console.error(err);
        setError("Failed to fetch admin details");
      } finally {
        setLoading(false);
      }
    };

    getAdmin();
  }, [id]);

  const handleUpdate = async () => {
    if (!password) {
      toast.error("Password cannot be empty");
      return;
    }
    try {
      await updateAdminPassword(id, { password });
      toast.success("Password updated successfully");
      navigate(-1);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update password");
    }
  };

  if (loading) {
    return (
      <div className="text-center p-4">
        <Spinner color="primary" />
      </div>
    );
  }

  if (error) {
    return <Alert color="danger">{error}</Alert>;
  }

  return (
    <div className="page-content d-flex justify-content-center">
      <Card className="shadow-sm w-50">
        <CardHeader className="d-flex justify-content-between align-items-center bg-primary text-white">
          <h5 className="mb-0">Update Admin Password</h5>
          <Button color="secondary" size="sm" onClick={() => navigate(-1)}>
            Back
          </Button>
        </CardHeader>
        <CardBody>
          <Form>
            <FormGroup>
              <Label>Email</Label>
              <Input type="email" value={admin.email} disabled />
            </FormGroup>

            <FormGroup className="mt-3">
              <Label>New Password</Label>
              <Input
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </FormGroup>

            <div className="d-flex justify-content-end mt-4">
              <Button color="primary" onClick={handleUpdate}>
                Update Password
              </Button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default UpdateAdminPassword;
